/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEnlarge = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4 4H2V2h2zm3 0H5V2h2zm3 0H8V2h2zm3 0h-2V2h2zm3 0h-2V2h2zm3 0h-2V2h2zm3 0h-2V2h2zM4 7H2V5h2zm18 0h-2V5h2zM4 10H2V8h2zm18 0h-2V8h2zm0 3h-2v-2h2zm0 3h-2v-2h2zm0 3h-2v-2h2zm-6 3h-2v-2h2zm3 0h-2v-2h2zm3 0h-2v-2h2zm-10-8.586V22H2V12h8.586l3-3H10V7h7v7h-2v-3.586zM10 14H4v6h6z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgEnlarge as Enlarge };
